import { useEffect, useMemo } from "react";
import { compose } from "redux";

import Link from "admin/shared/ui/Link.Component";

// markup
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";

// custom markup
import RetractableSidebar, {
  activeStyle,
} from "../../../home/components/Retractable.Sidebar";
import IconWithIndicator from "../../../home/components/Icon.With.Indicator";

// icons
import ApplicationsIcon from "@material-ui/icons/FindInPage";
import ReviewIcon from "@material-ui/icons/FindReplace";
import PreReviewIcon from "@material-ui/icons/ChangeHistory";
import LoansIcon from "@material-ui/icons/AccountBalanceWallet";
import TransactionsIcon from "@material-ui/icons/CompareArrows";
import DeleteForeverIcon from "@material-ui/icons/DeleteForever";
import TabUnselectedIcon from "@material-ui/icons/TabUnselected";
import SvgIcon from "@material-ui/core/SvgIcon";

import { newLoansConnector } from "../../../../services/menu/newLoans/connector";
import AutogiroIcon from "@material-ui/icons/History";
import OrdersIcon from "@material-ui/icons/Reorder";
import { menuOrdersConnector } from "../../../../services/orders/menuConnector";

const NewLoansComponent = (props) => {
  useEffect(() => {
    props.fetchNewLoansLoanData();
    props.fetchBorrowerOrdersData();
    props.getCreditApplications();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getFinanceIcon = () => {
    /// the euro icon
    return (
      <SvgIcon>
        <path d="M15 18.5c-2.51 0-4.68-1.42-5.76-3.5H15v-2H8.58c-.05-.33-.08-.66-.08-1s.03-.67.08-1H15V9H9.24C10.32 6.92 12.5 5.5 15 5.5c1.61 0 3.09.59 4.23 1.57L21 5.3C19.41 3.87 17.3 3 15 3c-3.92 0-7.24 2.51-8.48 6H3v2h3.06c-.04.33-.06.66-.06 1 0 .34.02.67.06 1H3v2h3.52c1.24 3.49 4.56 6 8.48 6 2.31 0 4.41-.87 6-2.3l-1.78-1.77c-1.13.98-2.6 1.57-4.22 1.57z" />
        <path d="M0 0h24v24H0z" fill="none" />
      </SvgIcon>
    );
  };

  let wrapperStyle = {
    display: "flex",
    minHeight: "100%",
  };

  let applicationsLen = props.applications ? props.applications.length : 0;
  let applications = (
    <IconWithIndicator
      icon={<ApplicationsIcon />}
      displayIndicator={applicationsLen}
      indicator={applicationsLen}
    />
  );

  const credApplicationsLen = useMemo(() => {
    return props.creditApplications ? props.creditApplications.length : 0;
  }, [props.creditApplications]);
  let credApplications = (
    <IconWithIndicator
      icon={<ApplicationsIcon />}
      displayIndicator={credApplicationsLen}
      indicator={credApplicationsLen}
    />
  );

  let applicationsReviewingLen = props.reviewingApplications
    ? props.reviewingApplications.length
    : 0;
  let applicationsReviewing = (
    <IconWithIndicator
      icon={<ReviewIcon />}
      displayIndicator={applicationsReviewingLen}
      indicator={applicationsReviewingLen}
    />
  );

  let credApplicationsReviewingLen = props.reviewingCreditApplications
    ? props.reviewingCreditApplications.length
    : 0;
  let credApplicationsReviewing = (
    <IconWithIndicator
      icon={<ReviewIcon />}
      displayIndicator={credApplicationsReviewingLen}
      indicator={credApplicationsReviewingLen}
    />
  );

  let payoutsLen = props.payouts ? props.payouts.length : 0;
  let payouts = (
    <IconWithIndicator
      icon={getFinanceIcon()}
      displayIndicator={payoutsLen}
      indicator={payoutsLen}
    />
  );

  let applicationsPreLen = props.preApplications
    ? props.preApplications.length
    : 0;
  let applicationsPre = (
    <IconWithIndicator
      icon={<PreReviewIcon />}
      displayIndicator={applicationsPreLen}
      indicator={applicationsPreLen}
    />
  );

  let restRepayPreLen = props.restRepayments ? props.restRepayments.length : 0;
  let restRepayPre = (
    <IconWithIndicator
      icon={<TabUnselectedIcon />}
      displayIndicator={restRepayPreLen}
      indicator={restRepayPreLen}
    />
  );

  let ordersLen =
    props.borrowerOrders && props.borrowerOrders.withdraw
      ? props.borrowerOrders.withdraw.data.length
      : 0;
  let orderList = (
    <IconWithIndicator
      icon={<OrdersIcon />}
      displayIndicator={ordersLen}
      indicator={ordersLen}
    />
  );

  return (
    <div style={wrapperStyle}>
      <RetractableSidebar storageKey="dashboard">
        <List>
          <Link
            activeClassName={"selected"}
            activeStyle={activeStyle}
            toState={"newLoansApplications"}
          >
            <ListItem button>
              <ListItemIcon>{applications}</ListItemIcon>
              <ListItemText primary="Applications" />
            </ListItem>
          </Link>
          <Link
            activeClassName={"selected"}
            activeStyle={activeStyle}
            toState={"newCreditApplications"}
          >
            <ListItem button>
              <ListItemIcon>{credApplications}</ListItemIcon>
              <ListItemText primary="CreditApplications" />
            </ListItem>
          </Link>
          <Link
            activeClassName={"selected"}
            activeStyle={activeStyle}
            toState={"underReviewApplications"}
          >
            <ListItem button>
              <ListItemIcon>{applicationsReviewing}</ListItemIcon>
              <ListItemText primary="On Hold" />
            </ListItem>
          </Link>
          <Link
            activeClassName={"selected"}
            activeStyle={activeStyle}
            toState={"underReviewCreditApplications"}
          >
            <ListItem button>
              <ListItemIcon>{credApplicationsReviewing}</ListItemIcon>
              <ListItemText primary="On Hold CredApps" />
            </ListItem>
          </Link>
          <Link
            activeClassName={"selected"}
            activeStyle={activeStyle}
            toState={"preApplications"}
          >
            <ListItem button>
              <ListItemIcon>{applicationsPre}</ListItemIcon>
              <ListItemText primary="Pre Applications" />
            </ListItem>
          </Link>
          <Link
            activeClassName={"selected"}
            activeStyle={activeStyle}
            toState={"newLoansPayout"}
          >
            <ListItem button id="payoutItem">
              <ListItemIcon>{payouts}</ListItemIcon>
              <ListItemText primary="Payout" />
            </ListItem>
          </Link>
          <Link
            activeClassName={"selected"}
            activeStyle={activeStyle}
            toState={"autogiro"}
          >
            <ListItem button>
              <ListItemIcon>
                <AutogiroIcon />
              </ListItemIcon>
              <ListItemText primary="Payments" />
            </ListItem>
          </Link>
          <Link
            activeClassName={"selected"}
            activeStyle={activeStyle}
            toState={"newLoansLoans"}
          >
            <ListItem button>
              <ListItemIcon>
                <LoansIcon />
              </ListItemIcon>
              <ListItemText primary="Loans" />
            </ListItem>
          </Link>
          <Link
            activeClassName={"selected"}
            activeStyle={activeStyle}
            toState={"loanstepOrders"}
          >
            <ListItem button>
              <ListItemIcon>
                <ListItemIcon>{orderList}</ListItemIcon>
              </ListItemIcon>
              <ListItemText primary="Orders" />
            </ListItem>
          </Link>
          <Link
            activeClassName={"selected"}
            activeStyle={activeStyle}
            toState={"restRepaymentLoans"}
          >
            <ListItem button>
              <ListItemIcon>{restRepayPre}</ListItemIcon>
              <ListItemText primary="Rest Repayment" />
            </ListItem>
          </Link>
          <Link
            activeClassName={"selected"}
            activeStyle={activeStyle}
            toState={"specialAccounts"}
          >
            <ListItem button>
              <ListItemIcon>
                <TransactionsIcon />
              </ListItemIcon>
              <ListItemText primary="Withdraw/deposit special:" />
            </ListItem>
          </Link>
          <Link
            activeClassName={"selected"}
            activeStyle={activeStyle}
            toState={"ssnBlocking"}
          >
            <ListItem button>
              <ListItemIcon>
                <DeleteForeverIcon />
              </ListItemIcon>
              <ListItemText primary="Ssn Blocking" />
            </ListItem>
          </Link>
        </List>
      </RetractableSidebar>
      <div
        style={{
          //padding: '20px',
          width: "100%",
          boxSizing: "border-box",
          overflow: "auto",
          backgroundColor: "#f9f9f9",
        }}
      >
        {props.children}
      </div>
    </div>
  );
};
export default compose(
  newLoansConnector,
  menuOrdersConnector,
)(NewLoansComponent);
